import Multicanvascrosslinemanager from '@fusioncharts/features/src/multicanvas-crossline-manager';
export default Multicanvascrosslinemanager;
